module.exports = __webpack_public_path__ + "img/volume.1ac8feac.svg";